import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Typography, alpha } from '@mui/material';
import { HeaderBox } from './StyledComponents';
import MobileWatchListRow from './MobileWatchListRow';

// Memoized row component to prevent unnecessary re-renders
const MemoizedWatchListRow = memo(({ item, onClick }) => (
  <MobileWatchListRow item={item} onClick={onClick} />
));

MemoizedWatchListRow.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

const MobileWatchList = ({ filteredItems, toggleDrawer }) => {
  // Memoize the items list to prevent unnecessary re-renders
  const itemsList = useMemo(() => {
    return filteredItems.map((item) => (
      <Box
        component="div"
        key={item._id}
        sx={{
          marginBottom: '12px',
          paddingBottom: '8px',
          borderBottom: '1px solid rgba(145, 158, 171, 0.12)'
        }}
      >
        <MemoizedWatchListRow
          item={item}
          onClick={toggleDrawer}
        />
      </Box>
    ));
  }, [filteredItems, toggleDrawer]); // Only re-render when these props change

  return (
    <Box sx={{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      <Box sx={{
        position: 'sticky',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'background.paper',
        zIndex: 1050,
        width: '100%',
        margin: 0,
        padding: 0,
        borderRadius: 0,
        flexShrink: 0
      }}>
        <HeaderBox>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontSize: 11,
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                }}
              >
                Symbol
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                variant="subtitle2"
                align="left"
                sx={{
                  fontSize: 11,
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                }}
              >
                Bid
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                variant="subtitle2"
                align="center"
                sx={{
                  fontSize: 11,
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                }}
              >
                Ask
              </Typography>
            </Grid>
          </Grid>
        </HeaderBox>
      </Box>
      <Box sx={{
        overflow: 'auto',
        flex: 1,
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': { width: 6 },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: (theme) => alpha(theme.palette.grey[500], 0.3),
          borderRadius: 3
        }
      }}>
        {itemsList}
      </Box>
    </Box>
  );
};

MobileWatchList.propTypes = {
  filteredItems: PropTypes.array.isRequired,
  toggleDrawer: PropTypes.func.isRequired
};

export default MobileWatchList;
